var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconPercent = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-3.25 -3.25)" },
                React.createElement("path", { d: "M25.8,10.7L10.7,25.8" }),
                React.createElement("path", { d: "M15,12.3c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7\n\t\tC13.8,9.6,15,10.8,15,12.3C15,12.3,15,12.3,15,12.3z" }),
                React.createElement("path", { d: "M26.9,24.2c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7S26.9,22.7,26.9,24.2\n\t\tL26.9,24.2z" })))));
});
export default IconPercent;
//# sourceMappingURL=IconPercent.js.map